import { MfesStoreEvents } from "./mfes.store.events";
export const InMemoryMfesStoreTypeName = 'InMemoryMfesStore';
export class InMemoryMfesStore {
    constructor(eventBus) {
        this.items = [];
        this.eventBus = eventBus;
    }
    get() {
        return this.items;
    }
    store(items) {
        this.internalClear();
        for (const item of items) {
            this.items.push(item);
        }
        this.notifyDataChanged();
    }
    clear() {
        const length = this.items.length;
        this.internalClear();
        if (length > 0) {
            this.notifyDataChanged();
        }
    }
    async load() {
        let items = [];
        if (!this.dataRequestCallback) {
            return items;
        }
        try {
            items = await this.dataRequestCallback();
            this.store(items);
            return items;
        }
        catch (e) {
            console.error(e);
            throw new Error('Failed to load data from registered data request callback');
        }
    }
    onDataRequest(callback) {
        this.dataRequestCallback = callback;
    }
    register(context, callback) {
        return this.eventBus.registerBroadcast(this, InMemoryMfesStoreTypeName, MfesStoreEvents.EVENT_NAME, (event) => {
            var _a;
            callback.call(context, ((_a = event.data) === null || _a === void 0 ? void 0 : _a.mfes) || []);
        });
    }
    internalClear() {
        while (this.items.length > 0) {
            this.items.pop();
        }
    }
    notifyDataChanged() {
        this.eventBus.dispatchBroadcast(InMemoryMfesStoreTypeName, MfesStoreEvents.EVENT_NAME, {
            mfes: this.items
        });
    }
}
//# sourceMappingURL=data:application/json;base64,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